import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/primeng';

import { Campaign3KontableComponent } from 'app/views/campaign-3/components/campaign-3-kontable/campaign-3-kontable.component';
import { KontableComponent } from 'app/modules/UIKit/components/kontable/kontable.component';
import { BreadCrumbModel } from 'app/views/campaign-3/models/campaign-3-breadcrumb.model';

import { DistributionPromo } from 'app/views/campaign-3/models/campaign-3.model';
import { BasketImportService } from '../basket-import.service';
import { Basket } from '../baskets.model';
import { BasketService } from '../basket.service';
import { CalendarTranslateService } from 'app/modules/UIKit/services/calendarTranslate.service';

@Component({
  selector: 'app-basket-import-csv',
  templateUrl: './basket-import-csv.component.html',
  styleUrls: ['./basket-import-csv.component.css'],
})
export class BasketImportCsvComponent implements OnInit {


  @ViewChild('csvKontable')
  kontableComponent: Campaign3KontableComponent;

  /* === TABLE CONFIG === */
  paginationType: number = Campaign3KontableComponent.ServerPagination;
  textFilter = KontableComponent.TextFilter;
  selectFilter = KontableComponent.SelectFilter;
  dateFilter = KontableComponent.DateFilter;
  numberFilter = KontableComponent.NumberFilter;
  noFilter = KontableComponent.NoFilter;

  /* === STATE === */
  basketId: string = '';
  basketCsvList: DistributionPromo[] = [];

  breadcrumbs: Array<BreadCrumbModel> = [];
  actionStatusList: Array<{ label: string; value: string }> = [];
  scopeList: Array<{ label: string; value: string }> = [];

  translationsMap: { [key: string]: string } = {};

  showTable: boolean = false;
  showBreadCrumb: boolean = false;

  showModalImportCsv = false;
  disableImportBtn = false;

  constructor(
    private notifyService: MessageService,
    private translateService: TranslateService,
    private router: Router,
    private route: ActivatedRoute,
    public basketImportService: BasketImportService,
    public basketService: BasketService,
    public srvCalendar: CalendarTranslateService

  ) {
    this.subscribeToRouteParams();
  }

  ngOnInit(): void {
    this.initBreadCrumbs();
    this.loadFilterList();
  }




  /* ===================== DATA ===================== */

  private loadBasketPromos(basketId: string): void {
    this.basketService.getActivePromos(basketId).subscribe(
      res => {
        this.basketCsvList = res.data;
      },
      error => {
        console.error('Errore durante il caricamento delle promo del basket:', error);
        this.showErrorMessage(
          this.translateService.instant('common.generic_error')
        );
      }
    );
  }
  //todo: attivare quando ho la chiamata
  private loadImportCsvList(basketId: string): void {
    this.basketService.getActivePromos(basketId).subscribe(
      res => {
        this.basketCsvList = res.data;
      },
      error => {
        console.error('Errore durante il caricamento delle promo del basket:', error);
        this.showErrorMessage(
          this.translateService.instant('common.generic_error')
        );
      }
    );
  }

  /* ===================== ROUTING ===================== */

  private subscribeToRouteParams(): void {
    this.route.queryParams.subscribe(params => {
      this.basketId = params['basketId'];
      if (this.basketId) {
        this.basketImportService.basketId = this.basketId;
      }
    });
  }

  goToPromoDetail(row: DistributionPromo): void {
    const { id: promoId, campaign_id: campaignId } = row;

    if (!promoId || !campaignId) {
      console.error('Parametri mancanti per la navigazione promo', row);
      return;
    }

    const url = `/campaign-3/${campaignId}/promo/${promoId}`;
    this.router.navigate([url]);
  }

  /* ===================== UI ===================== */

  private initBreadCrumbs(): void {
    this.translateService.get([
      'breadCrumb.baskets_list',
      'breadCrumb.basketCsvList',
    ]).subscribe(translations => {
      this.breadcrumbs = [
        {
          code: 'bc1',
          description: translations['breadCrumb.baskets_list'],
          routerLink: '/baskets-list'
        },
        {
          code: 'bc2',
          description: translations['breadCrumb.basketCsvList'],
          routerLink: '/basket-promo-list'
        }
      ];
      this.showBreadCrumb = true;
    });
  }

  breadcrumbClicked(breadcrumb: BreadCrumbModel): void {
    if (breadcrumb.routerLink) {
      this.router.navigate([breadcrumb.routerLink]);
    }
  }

  private loadFilterList(): void {
    this.translateService.get([
      'common.active',
      'common.inactive',
      'campaign.emission',
      'campaign.fruition'
    ]).subscribe(translations => {

      this.translationsMap = translations;

      this.actionStatusList = [
        { label: '', value: '' },
        { label: translations['common.active'], value: '1' },
        { label: translations['common.inactive'], value: '0' }
      ];

      this.scopeList = [
        { label: '', value: '' },
        { label: translations['campaign.emission'], value: 'E' },
        { label: translations['campaign.fruition'], value: 'F' }
      ];

      this.showTable = true;
    });
  }

  translateState(value: string): string {
    return this.translationsMap[value === '1'
      ? 'common.active'
      : 'common.inactive'] || '';
  }

  translateRuleScope(value: string): string {
    return this.translationsMap[value === 'E'
      ? 'campaign.emission'
      : 'campaign.fruition'] || '';
  }

  private showErrorMessage(message: string): void {
    console.warn(message);
  }
  csvFile: File | null = null;
  onImportCsvFile() {
    this.showModalImportCsv = true;
  }
  onConfirmImportCsv(): void {
    if (!this.csvFile) {
      return;
    }

    const reader = new FileReader();

    reader.onload = () => {
      const text = reader.result as string;

      if (!this.isCsvSingleColumn(text)) {
        console.error('[onConfirmImportCsv] CSV non valido: numero colonne errato');
        return;
      }

      console.log(
        '[onConfirmImportCsv] import CSV prodotti',
        this.csvFile.name
      );


      this.basketService.importFromCsv(Number(this.basketId), this.csvFile).subscribe(res => {
        console.log(res);
      });

      this.closeImportCsvDialog();
    };

    reader.readAsText(this.csvFile);
  }

  closeImportCsvDialog(): void {
    this.showModalImportCsv = false;
  }


  //funzione che controllla che sia due colonne soltanto
  private isCsvSingleColumn(csvText: string): boolean {
    let isValid = true;

    if (!csvText) {
      isValid = false;
    }

    const lines = csvText
      .split('\n')
      .map(l => l.trim())
      .filter(l => l.length > 0);

    if (lines.length === 0) {
      isValid = false;
    }

    for (let i = 0; i < lines.length && isValid; i++) {
      const columns = lines[i].split(',');

      if (columns.length !== 1) {
        console.error(
          '[isCsvSingleColumn] riga non valida',
          'line:', i + 1,
          'columns:', columns.length
        );

        this.notifyService.add({
          severity: 'error',
          summary: this.translateService.instant('common.error'),
          detail: this.translateService.instant('basketList.not_single_column_csv'),
          life: 5000,
        });

        isValid = false;
      }
    }

    return isValid;
  }

  onNewImportFromCsv(): void {

    this.showModalImportCsv = true;

  }


  onCsvDragOver(event: DragEvent): void {
    event.preventDefault();
  }

  onCsvDragLeave(event: DragEvent): void {
    event.preventDefault();
  }

  onCsvDrop(event: DragEvent): void {
    event.preventDefault();

    if (!event.dataTransfer || !event.dataTransfer.files || event.dataTransfer.files.length === 0) {
      return;
    }

    const file = event.dataTransfer.files[0];

    if (file.type !== 'text/csv' && !file.name.endsWith('.csv')) {
      console.error('[onCsvDrop] file non CSV', file);
      return;
    }

    this.csvFile = file;
  }

  onCsvFileSelected(event: any): void {
    if (!event || !event.target || !event.target.files || event.target.files.length === 0) {
      return;
    }

    const file = event.target.files[0];

    if (!file.name.endsWith('.csv')) {
      console.error('[onCsvFileSelected] file non CSV', file);
      this.notifyService.add({
        severity: 'error',
        summary: this.translateService.instant('common.error'),
        detail: this.translateService.instant('basketList.not_csv_file'),
        life: 5000,
      });
      return;
    }

    this.csvFile = file;
  }

  onTableDataLoaded(): void {
    if (this.kontableComponent && this.kontableComponent.filteredData) {
      this.disableImportBtn = this.kontableComponent.filteredData
        .some(row => String(row.flg_state) === '3');
    }
  }

  onOpenImportDetails(row: Basket): void {
    this.router.navigate(['/basket-import-articles'], {
      queryParams: { basketHeadId: row.id, basketId: this.basketId }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/views/baskets/basket-import-csv/basket-import-csv.component.ts